<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option
      v-for="item in optionList"
      :label="item.name"
      :value="item.supplierId"
      :key="item.supplierId"
    >
    </el-option>
  </el-select>
</template>

<script>
const businessLineMap = {
  1204: 1,
  1203: 2,
}
export default {
  name: 'filter-businessline-partner',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    code: {
      type: null,
    },
    name: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showDefault: {
      type: Boolean,
      default: false
    },
    businessLine: [String, Number],
  },

  data() {
    return {
      partnerList: [],
      optionList: [],
      optionMap: {},
    }
  },

  // created() {
  //   this.getOptionList()
  // },

  computed: {
    selectedValue: {
      get() {
        return this.value ? +this.value : ''
      },
      set(val) {
        const { supplierId = '', supplierCode = '', name = '' } = this.optionMap[val] || {}
        this.$emit('update:value', supplierId)
        this.$emit('update:code', supplierCode)
        this.$emit('update:name', name)
      },
    },
  },

  watch: {
    businessLine: {
      handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          this.selectedValue = ''
          this.optionList = []
        }
        this.getOptionList()
      },
      immediate: true
    }
  },

  methods: {
    getOptionList() {
      if (this.optionList.length > 0 || !this.businessLine) return
      const params = {
        businessLine: businessLineMap[this.businessLine] || this.businessLine
      }
      this.fetch
        .get('querySupplierByBusinessLine', { params })
        .then((res) => {
          this.optionList = res.data || []
          this.optionList.forEach((item) => {
            this.optionMap[item.supplierId] = item
          })
          if ((this.required || this.showDefault) && !this.value && this.optionList[0]) {
            this.selectedValue = this.optionList[0].supplierId
          }
          setTimeout(() => {
            this.$emit('initFetch')
          }, 500)
        })
        .catch(() => {})
    },
  },
}
</script>
